/* eslint @typescript-eslint/no-explicit-any: 0 */
import { curryN } from "ramda";
import isPojo from "./isPojo.mjs";
import mapObj from "./mapObj.mjs";
function modifyKeysRecursive(f, x) {
    if (Array.isArray(x)) {
        return x.map((v) => modifyKeysRecursive(f, v));
    }
    if (isPojo(x)) {
        return mapObj(f, (v) => modifyKeysRecursive(f, v), x);
    }
    return x;
}
export default curryN(2, modifyKeysRecursive);
//# sourceMappingURL=modifyKeysRecursive.mjs.map